import {
  ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES,
  ACCEPTED_VIDEO_MIME_TYPES,
  ACCEPTED_IMAGE_MIME_TYPES_NO_SVG,
} from 'screens/Finder/components/views/GalleryView/constants'
import { SupportedMediaType } from 'components/Wizards/schemas/Types'

export const getMimeTypesForMediaTypes = (mediaTypes: SupportedMediaType[]) => {
  if (mediaTypes.includes('image') && mediaTypes.includes('video')) {
    return ACCEPTED_IMAGE_AND_VIDEO_MIME_TYPES
  } else if (mediaTypes.includes('video')) {
    return ACCEPTED_VIDEO_MIME_TYPES
  } else {
    return ACCEPTED_IMAGE_MIME_TYPES_NO_SVG
  }
}
